import { Container, Grid, Text, Link, Accordion } from "basis";
import { useEventTracking } from "react-event-tracker";
import styles from "./faq.module.scss";

function FAQ() {
  const { trackEvent } = useEventTracking();
  return (
    <div className={styles.wrapper}>
      <div>
        <Container
          hasBreakpointWidth
          padding="10 0"
          padding-md="14 0"
          textAlign="center"
        >
          <Grid preset="page" rowsGap="8">
            <Grid.Item colSpan="all">
              <Text as="h3" textStyle="heading3">
                Have questions?
                <br />
                We've got answers.
              </Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-lg="2-9">
              <Accordion
                onItemToggle={({ isOpen, itemHeaderChildren }) => {
                  if (isOpen) {
                    trackEvent({
                      event: {
                        category: "accordion",
                        action: "in-page-navigation",
                        location: "Have questions?",
                        label: itemHeaderChildren,
                      },
                    });
                  }
                }}
              >
                <Accordion.Item>
                  <Accordion.Item.Header>
                    What is the Latitude Service Centre?
                  </Accordion.Item.Header>
                  <Accordion.Item.Content>
                    <Text>
                      The Latitude Service Centre is our new servicing platform
                      which replaces individual product specific Online
                      Servicing Centre. The Latitude Service Centre allows you
                      to manage all of your Latitude Credit Card and Personal
                      Loan accounts, 24 hours a day, with access to your account
                      balance, available credit and transaction history.
                    </Text>
                  </Accordion.Item.Content>
                </Accordion.Item>
                <Accordion.Item>
                  <Accordion.Item.Header>
                    What is my Latitude ID?
                  </Accordion.Item.Header>
                  <Accordion.Item.Content>
                    <Text>
                      Your Latitude ID is the email address you used to register
                      for the Latitude Mobile app or Latitude Service Centre.
                      Your Latitude ID is the username that will be used so you
                      can logon to our servicing platforms to manage your
                      Latitude products. The email address you use for your
                      Latitude ID must be an email address you own, but does not
                      have to be the same as the email address you used when
                      signing up for Latitude products.
                    </Text>
                  </Accordion.Item.Content>
                </Accordion.Item>
                <Accordion.Item>
                  <Accordion.Item.Header>
                    How do I get started?
                  </Accordion.Item.Header>
                  <Accordion.Item.Content>
                    <Text>
                      You will need to create a unique Latitude ID using your
                      email address. Once you have successfully completed the
                      registration you will be able to link all of your Latitude
                      Credit Card and Personal Loan products, so you can see and
                      manage them when you log in to Latitude Service Centre or
                      the Latitude app. Latitude creates this ID to keep your
                      details secure, and make signing in easy.
                    </Text>
                  </Accordion.Item.Content>
                </Accordion.Item>
                <Accordion.Item>
                  <Accordion.Item.Header>
                    How do I reset my password?
                  </Accordion.Item.Header>
                  <Accordion.Item.Content>
                    <Text>
                      Click on the 'Forgot password' link on the login page and
                      follow the prompts.
                    </Text>
                  </Accordion.Item.Content>
                </Accordion.Item>
              </Accordion>
            </Grid.Item>
            <Grid.Item colSpan="all">
              <Link
                appearance="secondary-button"
                width="200"
                href="/faq"
                newTab={false}
                onClick={() => {
                  trackEvent({
                    event: {
                      category: "button-link",
                      action: "internal-link",
                      location: "Have questions?",
                      label: "View more FAQs",
                    },
                  });
                }}
              >
                View more FAQs
              </Link>
            </Grid.Item>
          </Grid>
        </Container>
      </div>
    </div>
  );
}

export { FAQ };
